  
import {useMemo} from 'react';

 
import {useUserData} from '../../../contexts/UserContext/useUserData';
import {useGetRequest} from '../../../hooks/useGetRequest';
import {getApplicantCultureInformation} from '../../../lib/api/v1/applicant-culture';
import CultureInformationSerializer from '../../../serializers/CultureInformationSerializers';
import {ApplicantRoleData} from '../../../types/User';

export const useApplicantCulturePage = () => {
  const {currentUser} = useUserData();
  const applicantId = (currentUser?.role?.data as ApplicantRoleData)?.applicantId;

  const fetchData = useMemo(() => () => getApplicantCultureInformation(applicantId), [applicantId]);
  const {data: cultureInformation, loading, error} = useGetRequest(fetchData, CultureInformationSerializer.toObject);

  return {
    cultureInformation,
    loading,
    error,
  };
};
